// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3SlKP","title":"Images45_title__3UXOY","images":"Images45_images__1Uq0w"};